import compact from 'lodash/compact';
import map from 'lodash/map';
import { useCallback } from 'react';

import { type UploadInfo, type UserDocumentUploadTypeType } from '../types/upload';
import { CREATE_DOCUMENT_UPLOAD_MUTATION_QUERY } from '../apollo/graphql/upload.mutation';
import { jerry2Uri } from '../apollo';

/**
 * Hook to save document upload
 */
export const useSaveDocumentUpload = (
  userID: string,
  uploadType?: UserDocumentUploadTypeType
): ((uploads: Array<UploadInfo>) => Promise<string[]>) => {
  const uploadDocumentUpload = useCallback(
    async (uploadInfo: UploadInfo): Promise<string | undefined> => {
      const formData = new FormData();
      formData.append(
        'operations',
        JSON.stringify({
          query: CREATE_DOCUMENT_UPLOAD_MUTATION_QUERY,
          variables: {
            input: {
              uploadType,
              visibleToUser: true,
              userID,
              ignoreBusinessHours: false,
              emailToUser: false,
            },
          },
        })
      );

      formData.append(
        'map',
        JSON.stringify({
          '0': ['variables.input.upload'],
        })
      );

      formData.append('0', uploadInfo.upload);

      const response = await fetch(jerry2Uri, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();
      return result.data?.createUserDocumentUpload.userDocumentUploadEdge.node.id;
    },
    [uploadType, userID]
  );

  return useCallback(
    async (uploads: Array<UploadInfo>): Promise<string[]> => {
      const results = await Promise.all(
        map(uploads, async (upload) => {
          return uploadDocumentUpload(upload);
        })
      );
      return compact(results);
    },
    [uploadDocumentUpload]
  );
};
